import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { OptionContainer, OptionFlag, OptionLabel } from './mixins';
import Countries from './countries';
import PhoneInputComponent from './PhoneInputComponent';
var MIN_PHONE_LENGTH = 7;
var MAX_LENGTH_NUMBER = 20;

var Option = function Option(_ref) {
  var flag = _ref.flag,
      dialCode = _ref.dialCode;
  return React.createElement(OptionContainer, null, React.createElement(OptionFlag, {
    src: flag
  }), React.createElement(OptionLabel, null, "+", dialCode));
};

var countriesCode = Countries.map(function (country) {
  return {
    value: country.dialCode,
    label: React.createElement(Option, {
      flag: country.flag,
      dialCode: country.dialCode
    }),
    code: country.code
  };
});
var countriesReverseCode = countriesCode.reduce(function (accumulator, currentValue) {
  accumulator[currentValue.value] = currentValue;
  return accumulator;
}, {});

var isValidFormat = function isValidFormat(prefijo, numero) {
  return isValidPhoneNumber("".concat(prefijo).concat(numero), countriesReverseCode[prefijo].code);
};

var validatePrefijoAndNumber = function validatePrefijoAndNumber(prefijo, numero) {
  return prefijo && numero ? numero.length < MIN_PHONE_LENGTH || !isValidFormat(prefijo, numero) : false;
};

var PhoneInput = function PhoneInput(_ref2) {
  var value = _ref2.value,
      onChange = _ref2.onChange,
      defaultPrefix = _ref2.defaultPrefix,
      _ref2$validateFormat = _ref2.validateFormat,
      validateFormat = _ref2$validateFormat === void 0 ? true : _ref2$validateFormat,
      _ref2$fieldOptions = _ref2.fieldOptions,
      fieldOptions = _ref2$fieldOptions === void 0 ? {} : _ref2$fieldOptions,
      placeholder = _ref2.placeholder,
      rules = _ref2.rules,
      disabled = _ref2.disabled;
  var label = fieldOptions.label,
      _fieldOptions$formatE = fieldOptions.formatErrorText,
      formatErrorText = _fieldOptions$formatE === void 0 ? 'Ingresa un teléfono válido.' : _fieldOptions$formatE,
      _fieldOptions$maxHeig = fieldOptions.maxHeight,
      maxHeight = _fieldOptions$maxHeig === void 0 ? '290px' : _fieldOptions$maxHeig;

  var _useState = useState(function () {
    var _a;

    return {
      // eslint-disable-next-line prettier/prettier
      prefijo: (value === null || value === void 0 ? void 0 : value.prefijo) && countriesReverseCode[value.prefijo] ? value.prefijo : defaultPrefix,
      numero: (_a = value === null || value === void 0 ? void 0 : value.numero) !== null && _a !== void 0 ? _a : ''
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      phone = _useState2[0],
      setPhone = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      formatError = _useState4[0],
      setFormatError = _useState4[1];

  var errorMessageHandler = function errorMessageHandler(prefijo, numero) {
    if (validateFormat) {
      var isError = validatePrefijoAndNumber(prefijo, numero);
      setFormatError(isError);
    }
  };

  var changeInputHandler = function changeInputHandler(prefijo, numero) {
    // Solo numeros
    if (numero && (!/^\d+$/.test(numero) || numero.length > MAX_LENGTH_NUMBER)) {
      return;
    }

    setPhone({
      prefijo: prefijo,
      numero: numero
    });

    if (prefijo && numero) {
      onChange({
        prefijo: prefijo,
        numero: numero
      }, validateFormat ? numero.length >= MIN_PHONE_LENGTH && isValidFormat(prefijo, numero) : true);
    } else {
      onChange(null, true);
    }
  }; // Ejecutamos una validacion del telefono precargado


  useEffect(function () {
    errorMessageHandler(phone.prefijo, phone.numero);
    changeInputHandler(phone.prefijo, phone.numero);
  }, []);
  return React.createElement(PhoneInputComponent, {
    countriesReverseCode: countriesReverseCode,
    phone: phone,
    countriesCode: countriesCode,
    formatError: formatError,
    errorMessageHandler: errorMessageHandler,
    changeInputHandler: changeInputHandler,
    label: label,
    rules: rules,
    maxHeight: maxHeight,
    placeholder: placeholder,
    setFormatError: setFormatError,
    formatErrorText: formatErrorText,
    disabled: disabled
  });
};

export default PhoneInput;